import { FormEvent, useEffect, useState } from "react"
import { getUrlSearchParams } from "../urlParams"
import removeAllErrorMsg from "../../components/funcRemoveAllErros"
import { toast } from "react-toastify"
import funcSleep from "../../components/funcSleep"
import { ApiEndpoints, reqGetNew, reqPatch, reqPostNew, reqPut } from "../../config/apiClient"
import LoadingModal from "../../components/loadingModal"
import { Button, Col, Form, Row } from "react-bootstrap"
import Select from "react-select"
import dayjs from "dayjs"
import QrCodeUltimosRegistros from "./QrCodeUltimosRegistros"
import QrCodeCadastrarStatus from "./QrCodeCadastrarStatus"
import { getCookie } from "../../config/cookies"
import styles from '../colaborador/styles/colaborador.module.css'

export default function QrCodeCadastrarPage() {

    useEffect(() => {

        document.title = "Cadastrar QRCode Ronda | OB PORTUS"

        const urlDados = getUrlSearchParams()
        const id = urlDados.get("id")

        const getDados = async (id:number) => {
            setLoading(true)

            const apiFiltros = await reqGetNew(ApiEndpoints.qrcodeCadastrarFiltros)

            if (apiFiltros.status === 200) {
                const dados = apiFiltros.data
                let empresasAux = dados.empresas.map((item:any, index:any) => (
                    {
                        "value": `${item.codigo}`,
                        "label": `${item.codigo} - ${item.nome}`
                    }
                ))
                setEmpresasFiltro(empresasAux)
                let centrosAux = dados.centros_custo.map((item:any, index:any) => (
                    {
                        "value": `${item.codigo}`,
                        "label": `${item.codigo} - ${item.centro_custo}`
                    }
                ))
                setCentrosFiltro(centrosAux)
            }

            if (id === null || id === 0) {
                setLoading(false)
                return
            }

            setLoading(false)
        }

        const idQrcode = Number(id)
        getDados(idQrcode)

        if (idQrcode > 0) {
            loadQrCode(idQrcode)
        }

        if (id !== null) {
            document.title = "Editar QRCode Ronda | OB PORTUS"
        }
        // eslint-disable-next-line
    }, [])

    async function loadQrCode(id: number) {
        const dados = {
            id_qrcode: id
        }

        const api = await reqPostNew(ApiEndpoints.qrcodeConsultar, dados)

        if (api.status === 200) {
            const qrcode = api.data
            setQrcodeDados(qrcode)
            setEmpresa({
                "value": `${qrcode.id_empresa.codigo}`,
                "label": `${qrcode.id_empresa.codigo} - ${qrcode.id_empresa.nome}`
            })
            setCentroCusto({
                "value": `${qrcode.id_centro_custo.codigo}`,
                "label": `${qrcode.id_centro_custo.codigo} - ${qrcode.id_centro_custo.centro_custo}`
            })
            let form:any = document.getElementById("formQrCodeSite")
            form.descricao.value = qrcode.descricao
            form.sub_descricao.value = qrcode.sub_descricao
            form.obs.value = qrcode.obs
            form.latitude.value = qrcode.latitude
            form.longitude.value = qrcode.longitude
            form.mode_camera.checked = qrcode.mode_camera === 1 ? true : false
            form.mode_nfc.checked = qrcode.mode_nfc === 1 ? true : false

            // defineTextInHtml("md5hash", qrcode.md5hash)
            // defineTextInHtml("data_criacao", `Criado em ${dayjs(qrcode.data_criacao).format("DD/MM/YYYY HH:mm:ss")}`)
        }

        setLoading(false)
    }

    const [qrcodeDados, setQrcodeDados] = useState<any>({})
    const [loading, setLoading] = useState<boolean>(false)
    const [mostrarUltimosRegistros, setMostrarUltimosRegistros] = useState<boolean>(false)
    const [empresa, setEmpresa] = useState<any>({ "value": "", "label": "Não Selecionado" })
    const [empresasFiltro, setEmpresasFiltro] = useState<any[]>([])
    const [centroCusto, setCentroCusto] = useState<any>({ "value": "", "label": "Não Selecionado" })
    const [centrosFiltros, setCentrosFiltro] = useState<any[]>([])

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dados:QrCodeCadastrarDto = {
            id_qrcode: Object.values(qrcodeDados).length > 0 ? qrcodeDados.id_qrcode : null,
            id_centro_custo: Number(centroCusto.value),
            id_empresa: Number(empresa.value),
            mode_camera: form.mode_camera.checked === true ? 1 : 0,
            mode_nfc: form.mode_nfc.checked === true ? 1 : 0,
            descricao: form.descricao.value,
            sub_descricao: form.sub_descricao.value,
            longitude: form.longitude.value,
            latitude: form.latitude.value,
            obs: form.obs.value
        }

        if (dados.descricao === "") {
            form.descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.sub_descricao === "") {
            form.sub_descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.id_empresa === 0) {
            form.empresa_aux.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.id_centro_custo === 0) {
            form.centro_custo_aux.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.latitude === "") {
            dados.latitude = null
        }
        if (dados.longitude === "") {
            dados.longitude = null
        }
        if (dados.obs === "") {
            dados.obs = null
        }

        console.info(dados)

        if (!formValidado) {
            return
        }

        if (Object.values(qrcodeDados).length === 0) {
            cadastrar(dados)
        }

        if (Object.values(qrcodeDados).length > 0) {
            editar(dados)
        }
    
    }

    async function cadastrar(dados:any) {

        setLoading(true)

        const api = await reqPut(ApiEndpoints.qrcodeCadastrar, dados)

        if (api.status === 201) {
            console.log(api.data)

            toast.success('QRCode cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)
            setLoading(false)

            window.location.assign(`/qrcode/cadastros`)
        }
        setLoading(false)

    }

    async function editar(dados:any) {
        setLoading(true)

        const api = await reqPatch(ApiEndpoints.qrcodeEditar, dados)

        setLoading(false)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('QRCode editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/qrcode/cadastros`)
        }
    }

    async function handleDeletar() {
        if (!window.confirm("Tem certeza que deseja exluir o QRCode?")) {
            return
        }

        setLoading(true)
        
        const dados = {
            id_qrcode: Number(qrcodeDados.id_qrcode)
        }
        
        const api = await reqPostNew(ApiEndpoints.qrcodeDeletar, dados)

        if (api.status === 200) {
            toast.success('QRCode excluído com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            
            await funcSleep(500)
            
            window.location.assign(`/qrcode/cadastros`)
        } else {
            setLoading(false)
        }
    }

    async function handleRemoverNfc() {
        if (!window.confirm("Tem certeza que deseja remover NFC do QRCode?")) {
            return
        }

        setLoading(true)
        
        const dados = {
            id_qrcode: Number(qrcodeDados.id_qrcode)
        }
        
        const api = await reqPostNew(ApiEndpoints.qrcodeRemoverNfc, dados)

        if (api.status === 200) {
            toast.success('NFC Removido com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            loadQrCode(dados.id_qrcode)
        } else {
            setLoading(false)
        }
    }

    function handleMostrarUltimosRegistros() {
        setMostrarUltimosRegistros(!mostrarUltimosRegistros)
    }

    async function handleStatus(inativo: number) {
        const dados = {
            id_qrcode: qrcodeDados.id_qrcode,
            id_usuario: Number(getCookie('id_user')),
        }

        setLoading(true)
        if (inativo === 1) {
            const api = await reqPatch(ApiEndpoints.qrcodeInativar, dados)
            if (api.status === 200) {
                toast.success('QRCode INATIVADO com sucesso!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                await loadQrCode(qrcodeDados.id_qrcode)
            }
        }
        if (inativo === 0) {
            const api = await reqPatch(ApiEndpoints.qrcodeReativar, dados)
            if (api.status === 200) {
                toast.success('QRCode REATIVADO com sucesso!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                await loadQrCode(qrcodeDados.id_qrcode)
            }
        }
        setLoading(false)
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event:any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
                <div className="div-row">
                    <h1 id="titleMain">QRCode</h1>
                    {
                        Object.values(qrcodeDados).length > 0 &&
                        <QrCodeCadastrarStatus qrcode={qrcodeDados} />
                    }
                </div>
                <Button variant="secondary" onClick={() => {window.location.assign(`/qrcode/cadastros`)}}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formQrCodeSite' onSubmit={handleSubmit} style={{position: 'relative'}} noValidate>
                {
                    Object.values(qrcodeDados).length > 0 &&
                    <div style={{position: "absolute", top: 0, right: 0,}}>
                        <div style={{textAlign: "right"}}>
                            <img src={qrcodeDados.link} alt="qr_code" id="qr_code" style={{width: "128px"}} />
                            <p id="md5hash">{qrcodeDados.md5hash}</p>
                            <p id="data_criacao">{`Criado em ${dayjs(qrcodeDados.data_criacao).format("DD/MM/YYYY HH:mm:ss")}`}</p>
                            {
                                qrcodeDados.data_inativo !== null &&
                                <div>
                                    <p>{`Última vez inativado ${dayjs(qrcodeDados.data_inativo).format("DD/MM/YYYY HH:mm:ss")}`}</p>
                                    {
                                        qrcodeDados.id_usuario !== null &&
                                        <p>{`Por ${qrcodeDados.id_usuario.nome}`}</p>
                                    }
                                    {
                                        qrcodeDados.id_usuario === null &&
                                        <p>{`Por SISTEMA`}</p>
                                    }
                                </div>
                            }
                            {
                                qrcodeDados.nfc_tag_id !== null &&
                                <div>
                                    <p>NFC TAG - {qrcodeDados.nfc_tag_id}</p>
                                    <p>NFC vinculado em - {dayjs(qrcodeDados.data_nfc_vinculado).format("DD/MM/YYYY HH:mm:ss")}</p>
                                </div>
                            }
                        </div>
                    </div>
                }

                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name='descricao' type="text" id='descricao' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-6">
                        <Form.Check
                            type="switch"
                            id="mode_camera"
                            label="Habilitar registros de Ronda via Scanner de QR Code"
                            className={styles.inputCheck}
                        />
                        <Form.Check
                            type="switch"
                            id="mode_nfc"
                            label="Habilitar registros de Ronda via TAG NFC"
                            className={styles.inputCheck}
                        />
                    </Col>
                </Row>
                
                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Sub Descrição:</Form.Label>
                            <Form.Control name='sub_descricao' type="text" id='sub_descricao' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Sub Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                        <Form.Label>Empresa:</Form.Label>
                        <Select name='empresa' id='empresa' options={empresasFiltro} value={empresa} placeholder="Selecione a empresa" onChange={
                                (choice:any) => {
                                    setEmpresa(choice)
                                }
                            } styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: "#dee2e6"
                                }),
                            }} />
                        </Form.Group>
                        <Form.Control name='empresa_aux' type="text" id='empresa_aux' placeholder="" style={{display: "none"}}/>
                        <Form.Control.Feedback type="invalid">
                            Selecione a empresa do Cliente!
                        </Form.Control.Feedback>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                        <Form.Label>Centro de Custo:</Form.Label>
                        <Select name='centro_custo' id='centro_custo' options={centrosFiltros} value={centroCusto} placeholder="Selecione o Centro de Custo" onChange={
                                (choice:any) => {
                                    setCentroCusto(choice)
                                }
                            } styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: "#dee2e6"
                                }),
                            }} />
                        </Form.Group>
                        <Form.Control name='centro_custo_aux' type="text" id='centro_custo_aux' placeholder="" style={{display: "none"}}/>
                        <Form.Control.Feedback type="invalid">
                            Selecione o Centro de Custo!
                        </Form.Control.Feedback>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Latitude:</Form.Label>
                            <Form.Control name='latitude' type="text" id='latitude' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Latitude!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Longitude:</Form.Label>
                            <Form.Control name='longitude' type="text" id='longitude' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Longitude!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-12">
                        <Form.Group>
                            <Form.Label>Observação:</Form.Label>
                            <Form.Control name='obs' type="text" id='obs' placeholder=""/>
                        </Form.Group>
                    </Col>
                </Row>

                {
                    Object.values(qrcodeDados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(qrcodeDados).length > 0 &&
                    <div className="div-row">
                        <Button variant="success" type="submit" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                        <Button variant="danger" onClick={() => {handleDeletar()}} disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Deletar'}</Button>
                        <Button variant="warning" onClick={() => {handleMostrarUltimosRegistros()}} type="button" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Mostrar Últimos Registros'}</Button>
                        
                        {
                            qrcodeDados.inativo === 0 &&
                            <Button variant="secondary" onClick={() => {handleStatus(1)}} type="button" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Inativar'}</Button>
                        }
                        {
                            qrcodeDados.inativo === 1 &&
                            <Button variant="secondary" onClick={() => {handleStatus(0)}} type="button" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Reativar'}</Button>
                        }
                        <Button variant="danger" onClick={() => {handleRemoverNfc()}} disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Remover NFC'}</Button>
                    </div>
                }

                <br></br>
                <br></br>

                {
                    mostrarUltimosRegistros &&
                    <QrCodeUltimosRegistros id_qrcode={qrcodeDados.id_qrcode} />
                }
            </Form>
        </div>
    )
}

interface QrCodeCadastrarDto {
    id_qrcode: number | null
    id_centro_custo: number
    id_empresa: number
    mode_camera: number
    mode_nfc: number
    descricao: string
    sub_descricao: string
    latitude: string | null
    longitude: string | null
    obs: string | null
}
